import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Shield } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { user, role, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen app-bg flex items-center justify-center font-outfit">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-xl border-2 border-[hsl(var(--app-gold))] flex items-center justify-center gold-glow animate-pulse">
            <Shield className="w-6 h-6 text-[hsl(var(--app-gold))]" />
          </div>
          <p className="text-sm text-[hsl(var(--app-text-muted))]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || !role) {
    return <Navigate to="/app" replace />;
  }

  if (allowedRoles && role && !allowedRoles.includes(role)) {
    // Redirect to correct dashboard based on role
    const roleRoutes: Record<string, string> = {
      officer: "/app/officer",
      site_owner: "/app/site-owner",
      business_owner: "/app/business-owner",
      admin: "/app/admin",
    };
    return <Navigate to={roleRoutes[role] || "/app"} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
